module.exports = __webpack_public_path__ + "img/94b7f38.jpg";